const setNewEncodingPayload = (
  img,
  number_video,
  online,
  type,
  galleryEntity,
  deletedFiles,
  fireDepartment,
  images,
  iarMember,
  tempUpdatedFiles,
  gallerySectionActive,
  gallerySectionName,
  videos
) => {
  let deletedSeconds = 0
  deletedFiles.forEach((file) => {
    deletedSeconds += file.secondsDuration
  })
  const data = {
    title: 'gallery',
    richText: '',
    videosNumber: number_video,
    videos: [],
    images: img,
    onlineVideos: online,
    type: type,
    contentId: galleryEntity._id ? galleryEntity._id : '',
    positionFiles: 0,
    identifier: fireDepartment.identifier,
    fireDepartmentId: fireDepartment.fireDepartmentId,
    socketChannels: [
      `${fireDepartment.fireDepartmentId.toString()}_inner_gallery`,
      `${fireDepartment.fireDepartmentId.toString()}_gallery`
    ],
    deletedFiles,
    updatedFiles: tempUpdatedFiles,
    deletedSeconds,
    memberId: iarMember.memberId,
    sendPushNotifications: false,
    sectionActive: gallerySectionActive,
    sectionName: gallerySectionName
  }

  const formData = new FormData()

  formData.append('request', JSON.stringify(data))

  images.forEach((image) => {
    if (image.file === undefined) return

    formData.append('images', image.file, image.originalName)
    image.file = null
  })

  return formData
}

const getOnlineVideosPayload = (onlineVideos, fireDepartment) => {
  let onlineVideoPayload = []
  if (onlineVideos) {
    onlineVideoPayload = onlineVideos.map((v) => {
      return {
        fireDepartmentIdentifier: fireDepartment.identifier,
        originalName: v.originalName,
        type: 'online',
        fileName: `${v.url}_${Date.now().toString()}`,
        provider: v.provider,
        caption: v.caption,
        fileSize: '',
        url: v.url
      }
    })
  } else {
    onlineVideoPayload = onlineVideos
  }

  const online = []
  onlineVideoPayload.forEach((elem) => {
    online.push({
      fireDepartmentIdentifier: elem.fireDepartmentIdentifier,
      originalName: elem.originalName,
      caption: elem.caption,
      fileName: elem.fileName,
      type: elem.type,
      provider: elem.provider,
      url: elem.url,
      fileSize: elem.fileSize,
      binary: elem.binary
    })
  })

  return { online }
}



const getVideosPayload = (galleryEntity, videos) => {
  let vid = []
  if (galleryEntity.videos) {
    videos.forEach((video) => {
      let fileExists = !galleryEntity.videos.some((i) => {
        return i.fileName === video.fileName
      })

      if (fileExists) {
        vid.push({
          originalName: video.FileName,
          type: video.type,
          fileSize: video.fileSize,
          caption: video.caption,
          secondsDuration: video.secondsDuration,
          binary: video.binary
        })
      }
    })
  } else {
    vid = videos
  }
  return { vid }
}

const getImagesPayload = (galleryEntity, images) => {
  let img = []
    if (galleryEntity.images) {
      images.forEach((image) => {
        let fileExists = !galleryEntity.images.some((i) => {
          return i.fileName === image.fileName
        })

        if (fileExists) {
          img.push({
            binary: image.file,
            originalName: image.originalName,
            caption: image.caption,
            fileSize: image.fileSize,
            type: image.type
          })
        }
      })
    } else {
      img = images
    }

    return {img}
}

function entitySetter(current, setImages, setVideos, setOnlineVideos) {
  setImages(current.images ?? [])
  setVideos(current.videos ?? [])
  setOnlineVideos(current.onlineVideos ?? [])
}

async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}
export {
  setNewEncodingPayload,
  getOnlineVideosPayload,
  getVideosPayload,
  getImagesPayload,
  asyncForEach,
  entitySetter
}
